import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';
import Help from '../../../generics/help';



const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../../config');
var report = require('../../../generics/report_head');

class GeneralInfo extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		this.checking = this.checking.bind(this);

		this.showColumn = this.showColumn.bind(this);
		this.getColumns = this.getColumns.bind(this);

		this.getConvokePlace = this.getConvokePlace.bind(this);

		this.setTable = this.setTable.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.state = {
			health_facilities_id:"",
			health_facilities: [],

			extraction_type_id:"all",
			extraction_type:[],

			lab_sections_id:"all",
			lab_sections:[],

			start_date 	: "",//aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			end_date 	: "",//aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			start_folio:"",
			end_folio:"",

			convoke_places:[],
			national_center_id:"",

			table_list:[],
			listado:[],

			change_check: false,

			//test datatable to export
			columns:[],
			columns_default:[],
			filename:"Información General",
			search_by:"",
			fraction_columns:"",
			search_type:"date",

			statuses:[],
			status:"",
		}
	}

	componentWillMount(){
		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id')
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}

	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)
		this.getColumns('inicial');

		
		this.getConvokePlace();
	}

	getColumns(start){
		this.setState({
			columns:[{title: "Lugar de Colecta", width:'100px'},
					 {title: "Fecha", width:'100px'},
					 {title: "Apellidos", width:'100px'},
					 {title: "Nombres", width:'100px'},
					 {title: "No. donador", width:'100px'},
					 {title: "Sexo", width:'100px'},
					 {title: "Edad", width:'100px'},
					 {title: "Tipo Documento", width:'100px'},
					 {title: "No. Documento", width:'100px'},
					 {title: "Edo. Civil", width:'100px'},
					 {title: "Escolaridad", width:'100px'},
					 {title: "Escolaridad", width:'100px'},
					 {title: "Ocupación", width:'100px'},
					 {title: "Municipio", width:'100px'},
					 {title: "Estado", width:'100px'},
					 {title: "Apellidos (paciente)", width:'100px'},
					 {title: "Nombres(paciente)", width:'100px'},
					 {title: "Hospital", width:'100px'},
					 {title: "Parentesco", width:'100px'},
					 {title: "No. Unidad", width:'100px'},
					 {title: "Tipo Extraccion", width:'100px'},
					 {title: "Tipo Donacion", width:'100px'},
					 {title: "Grupo", width:'100px'},
					 {title: "RH", width:'100px'},
					 {title: "Estatura", width:'100px'},
					 {title: "Peso", width:'100px'},
					 {title: "Frecuencia Respiratoria", width:'100px'},
					 {title: "Frecuencia Cardiaca", width:'100px'},
					 {title: "P. Maxima", width:'100px'},
					 {title: "P. Minima", width:'100px'},
					 {title: "Hemoglobina", width:'100px'},
					 {title: "Hematocrito", width:'100px'},
					 {title: "Lucocitos", width:'100px'},
					 {title: "Plaquetas", width:'100px'},
					 {title: "H. Clinica (estatus)", width:'100px'},
					 {title: "H. Clinica (motivo)", width:'100px'},
					 {title: "Tipo incidente", width:'100px'},
					 {title: "Motivo", width:'100px'},
					 {title: "Incidente Unidad", width:'100px'},
					 {title: "Motivo", width:'100px'},
					 {title: "Componente 1", width:'100px'},
					 {title: "Componente 2", width:'100px'},
					 {title: "Componente N", width:'100px'},
					 {title: "SIF", width:'100px'},
					 {title: "HEPC", width:'100px'},
					 {title: "HEPB", width:'100px'},
					 {title: "CHA", width:'100px'},
					 {title: "BRUC", width:'100px'}
			        ]
		});

		if(start === 'inicial'){
			setTimeout(()=>{
				this.setTable();
			}, 500);
		}	
		
	}

	setTable(){
		var fechas = "Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
					" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 

		this.$el = $(this.el);

		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename,
                	action: function( e, dt, node, config ){
                		open_modal();
                		setTimeout(()=>{
                			$.fn.dataTable.ext.buttons.excelHtml5.action.call(this, e, dt, node, config);

                			var time = dt.rows()[0].length * 100;

	      					setTimeout(()=>{
	                			close_modal();
	                		},time)
                		}, 1000);
	                    
	                }
            	},
            	],
			data: this.state.listado,
			columns:this.state.columns,
			oLanguage:{
				"sProcessing":"Procesando...",
				"sLengthMenu":"Mostrar _MENU_ registros",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"},
					"fnInfoCallback":null,
			},
			paging:false,
			responsive:false,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			ordering:true,
			createdRow: function(row, data, dataIndex){
                // If name is "Ashton Cox"
                if(data[1] === "		"){
                    // Add COLSPAN attribute
                    //console.log(row, data)
                    //data[1] = "";
                    $('td ', row).attr('colspan', 7);
                    $('td', row).eq(5).addClass('table_row');
                }
            }
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}

		const open_modal = () =>{
			this.props.waiting.handleShow('Generando Archivo');
		}

		const close_modal = ()=>{
			this.props.waiting.handleClose();
		}

	}

	export = () => {
        this._exporter.save();
    }

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		if(document.getElementById(e.target.name).className.includes('error')){
			document.getElementById(e.target.name).classList.remove('error');
		}

		if(e.target.name === 'health_facilities_id'){
			/*setTimeout(()=>{
				this.getConvokePlace();
				this.getLabSection();
			}, 500);*/
				
		}else if(e.target.name === 'search_type'){
			this.setState({
				start_date 	: "",
				end_date 	: "",
				start_folio:"",
				end_folio:"",
			})
		}
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				this.getColumns();

				this.props.waiting.handleShow('Buscando...');

				var object = {};
				object.start_date = this.state.start_date;
				object.end_date = this.state.end_date;
				object.health_facilities_id = sessionStorage.getItem('health_facilities_id');

				var fecha1 = moment(this.state.start_date);
				var fecha2 = moment(this.state.end_date);

				var dias = fecha2.diff(fecha1, 'days');


				if(dias <= 40){
					fetch(Config.default.apiGateway.URL+'reports/report_donor_information', {
						method : 'post',
						body:JSON.stringify(object),
						responseType: 'blob', //Force to receive data in a Blob Format
						headers : new Headers({
							'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
							'Content-Type': 'application/json'
						})
					})
					.then(res => {
						this.props.waiting.handleClose();
						if(res.ok){
							return res.json();
						}else{
							res.text().then((msg)=>{
								swal('Error', msg, 'error');
							});
						}
					})
					.then(response => {
						
						if (response !== undefined && response !== null) { 
							var list = [];
							//console.log(response)

							var columns = [{title: "Lugar de Colecta", width:'250px'},
								{title: "Fecha", width:'130px'},
								{title: "Apellidos", width:'200px'},
								{title: "Nombres", width:'150px'},
								{title: "No. donador", width:'90px'},
								{title: "Sexo", width:'80px'},
								{title: "Edad", width:'60px'},
								{title: "Tipo Documento", width:'150px'},
								{title: "No. Documento", width:'150px'},
								{title: "Edo. Civil", width:'150px'},
								{title: "Escolaridad", width:'200px'},
								{title: "Ocupación", width:'200px'},
								{title: "Municipio", width:'250px'},
								{title: "Estado", width:'250px'},
								{title: "Apellidos (paciente)", width:'200px'},
								{title: "Nombres(paciente)", width:'150px'},
								{title: "Hospital", width:'300px'},
								{title: "Parentesco", width:'200px'},
								{title: "No. Unidad", width:'100px'},
								{title: "Tipo Extraccion", width:'150px'},
								{title: "Tipo Donacion", width:'150px'},
								{title: "Tipo incidente", width:'150px'},
								{title: "Motivo", width:'200px'},
								{title: "Incidente Unidad", width:'150px'},
								{title: "Motivo", width:'150px'}];
							for (var i = 0; i < response.length; ++i) {

								var obj = [response[i].convoke_places,
										response[i].timestamp_date !== null ?
										moment(response[i].timestamp_date).format('DD/MM/YYYY') : "",
										response[i].lastnames,
										response[i].names,
										response[i].donor_number,
										response[i].sex,
										response[i].donor_age,
										response[i].document_type,
										response[i].document_number,
										response[i].civil_status,
										response[i].scolarship,
										response[i].job_profile,
										response[i].municipio,
										response[i].estado,
										response[i].patient_lastnames,
										response[i].patient_names,
										response[i].national_center,
										response[i].patient_relationship_value,
										response[i].donation_number,
										response[i].extraction_type,
										response[i].donation_type,
										response[i].type_incident || "",
										response[i].type_motivo || "",
										response[i].unit_incident || "",
										response[i].unit_motivo || ""
										];
									
									
								for (var a = 0; a < response[i].biometrics.length; ++a) {
									if (i===0) {
										columns.push({title: response[i].biometrics[a].name, width:'100px'})
									}

									if (response[i].biometrics[a].value === null) {
										response[i].biometrics[a].value = "";
									}

									obj.push(response[i].biometrics[a].value);
								}

								for (var b = 0; b < response[i].components.length; ++b) {
									if (i===0) {
										columns.push({title: response[i].components[b].name, width:'150px'})
									}

									if (response[i].components[b].value === null) {
										response[i].components[b].value = "";
									}

									obj.push(response[i].components[b].value);
								}

								for (var c = 0; c < response[i].samples.length; ++c) {
									if (i===0) {
										columns.push({title: response[i].samples[c].name, width:'150px'})
									}

									if (response[i].samples[c].value === null) {
										response[i].samples[c].value = "";
									}

									obj.push(response[i].samples[c].value);
								}

								list.push(obj);
								
							};

							//console.log(columns)
							setTimeout(()=>{
								this.props.waiting.handleShow('Cargando...');
								this.$el = $(this.el);
								this.$el.DataTable().destroy();
								this.$el.empty();
							}, 500);

							setTimeout(()=>{
								this.props.waiting.handleClose();
								this.setTable();
							}, 1000);

							this.setState({
								columns:columns,
								listado: list
							});
						}
							
					})
				}else{
					this.props.waiting.handleClose();
					swal('Error', 'La diferencia entre las fechas es de '+dias+' dias, la diferencia maxima entre la fecha desde y la fecha hasta debe ser de 40 dias', 'error')
				}

				
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}

		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;

		if(ini !== 'Invalid date' && fin !== 'Invalid date'){
			if(fin < ini){
				date_ok = false;
				document.getElementById('end_date').classList.add('error');
			}else{
				document.getElementById('end_date').classList.remove('error');
			}
		}else{
			date_ok = false;
		}		

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}

	showColumn(column_name){
    	var i =0;
      	for(i =0; i < this.state.columns.length;i++){
        	if(this.state.columns[i].column_key === column_name && this.state.columns[i].active){
          		return false;
        	}
      	} 
    	
    	return true;
 	}

 	getConvokePlace(){
 		var health = this.state.health_facilities_id;
 		
 		if(sessionStorage.getItem('matriz') === '1' && health === sessionStorage.getItem('health_facilities_id')){
 			health = 'all';
 		}

 		fetch(Config.default.apiGateway.URL+'convoke_places/by_hf?health_facilities_id='+health, {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					convoke_places: response
				});
			}
		});
 	}

 	

	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Donantes ->
					Información General
					</h5>
				</div>
				
				<Help 
					{...this.props}
		            menu={"help_donors"} 
		            submenu={"help_general_information"}  />
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
								
								<div className="col-xs-12 form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required  />
								</div>
								<div className="col-xs-12 form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
								
								
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12 col-sm-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline", fontSize:'16px'}}>
										<span>
											Información General
										</span>
									</div>
									<div className="col-xs-12 col-sm-12" >
										<span>
											Información Del:  {this.state.start_date !== "" ?
												moment(this.state.start_date).format("DD/MM/YYYY")
											: ''}    
										</span>
										<span style={{marginLeft:"5px"}}>	
											Al: {this.state.end_date !== "" ?
												moment(this.state.end_date).format("DD/MM/YYYY")
											: ''}
										</span>
									</div>
								</div>

								<div className="col-xs-12" id="table-to-pdf">
									<div className="table-responsive">

										<table style={{fontSize:"11px"}} className="expenses-discards" id="table-to-xls" ref={el => this.el = el}>
										</table>
									</div>

								</div>
							</div>
						</form>
					</div>
				</div>
			</div>
		)
	}
}

export default translate('translations') (GeneralInfo);